import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/goldenrush/images/logoMobile.png';

export default function Index() {
  return <Image src={logo} maxW="162px" position="relative" top="0.5" />;
}
